// extracted by mini-css-extract-plugin
module.exports = {"select":"Preacris_select__o8afP","row":"Preacris_row__3ddsF","button":"Preacris_button__1vu-S","input":"Preacris_input__1Lpl1"};